import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { authenticateBiometric, biometricKindLabel } from '../lib/biometricAuth';

const LOGO_SRC = Capacitor.isNativePlatform() ? '/icon-admin.png' : '/icon.png';

/// Full-screen gate shown when the admin app is signed-in but locked behind
/// Face ID / Touch ID. Auto-prompts on mount; user can retry or sign out.
export default function BiometricLock({ onUnlock, onSignOut }) {
  const [label, setLabel] = useState('Face ID');
  const [attempting, setAttempting] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    biometricKindLabel().then(setLabel);
    tryUnlock();
  }, []);

  const tryUnlock = async () => {
    if (attempting) return;
    setAttempting(true);
    setFailed(false);
    const ok = await authenticateBiometric(`Unlock Day Sheets`);
    setAttempting(false);
    if (ok) onUnlock();
    else setFailed(true);
  };

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div style={{ width:'100%', maxWidth:360, display:'flex', flexDirection:'column', alignItems:'center', gap:20, textAlign:'center' }}>
        <img src={LOGO_SRC} alt="Day Sheets"
          style={{ width:88, height:88, borderRadius:20, boxShadow:'0 6px 20px rgba(30,64,175,0.3)' }} />
        <div>
          <div style={{ fontSize:24, fontWeight:800, color:'#1E40AF', letterSpacing:-0.8 }}>Locked</div>
          <div style={{ marginTop:6, fontSize:14, color:'var(--text2)' }}>
            Unlock with {label} to view your day sheets.
          </div>
        </div>

        <button onClick={tryUnlock} disabled={attempting}
          style={{ width:'100%', padding:'14px', borderRadius:12, background:'#06B6D4',
            color:'#fff', border:'none', fontSize:16, fontWeight:700, cursor:'pointer',
            fontFamily:'inherit', opacity: attempting ? 0.6 : 1,
            boxShadow:'0 4px 14px rgba(6,182,212,0.3)' }}>
          {attempting ? 'Unlocking…' : `Unlock with ${label}`}
        </button>

        {failed && (
          <div style={{ fontSize:12, color:'var(--red)' }}>{label} check failed — try again or use your passcode.</div>
        )}

        <button onClick={onSignOut}
          style={{ background:'none', border:'none', color:'var(--text3)', fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:'inherit', padding:8 }}>
          Sign out
        </button>
      </div>
    </div>
  );
}
